import { WebglObject } from "../../../../../web-graphics";

export class SignalObject extends WebglObject {
  constructor(settings) {
    super(settings);
  }

  init() {}

  addData(/*data, dataSettings*/) {}

  getData(/*searchSettings*/) {}

  getDataCount() {
    return 0;
  }

  setFrequency(/*freq*/) {}

  getFrequency() {}

  setFilters(/*filters*/) {}

  getFilters() {
    return new []();
  }

  setScaleX(/*newScale*/) {}

  getScaleX() {}

  setScaleY(/*newScale*/) {}

  getScaleY() {}

  resetBuffer() {}
}
